import { ScaffolderInputHeader } from '@internal/plugin-scaffolder-common-field-react';
import React from 'react';

import { Box, Button, TextField } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

import { CICD_OIDC_SUBJECTS_INFO } from '../infoDoc';
import { useStyles } from '../styles';
import {
  duplicateCicdOidcSubjects,
  validateCicdOidcSubject,
} from '../validation';

interface CicdOidcSubjectsInputProps {
  formData: string[];
  onChange: (data: string[]) => void;
  rawErrors: string[];
  maxSubjects?: number;
  disabled?: boolean;
}

export const CicdOidcSubjectsInput = (props: CicdOidcSubjectsInputProps) => {
  const {
    formData,
    onChange,
    rawErrors,
    maxSubjects = 20,
    disabled = false,
  } = props;
  const classes = useStyles();

  const showErrors = rawErrors?.length > 0;

  const handleAddSubject = () => {
    onChange([...formData, '']);
  };

  const handleSubjectChange = (index: number, value: string) => {
    onChange(formData.map((subject, i) => (i === index ? value : subject)));
  };

  const handleRemoveSubject = (index: number) => {
    onChange(formData.filter((_, i) => i !== index));
  };

  const duplicates = duplicateCicdOidcSubjects(formData);

  return (
    <Box>
      <Box className={classes.inputContainer}>
        <ScaffolderInputHeader
          title="CI/CD OIDC subject claims"
          description="Allow GitHub Actions workflows and Azure DevOps pipelines to read and sync this project's applications."
          infoDoc={CICD_OIDC_SUBJECTS_INFO}
        />
      </Box>
      {formData.map((subject, index) => (
        <Box key={index} className={classes.flexContainer}>
          <Box className={classes.inputContainer}>
            <TextField
              id={`cicd-oidc-subject-${index}`}
              label="Subject claim"
              fullWidth
              variant="outlined"
              color="secondary"
              size="small"
              inputProps={{ maxLength: 255 }}
              value={subject}
              disabled={disabled}
              onChange={e => handleSubjectChange(index, e.target.value)}
              error={
                showErrors &&
                (!validateCicdOidcSubject(subject) ||
                  duplicates.has(subject.trim()))
              }
            />
          </Box>
          <Box marginBottom={2}>
            <Button
              variant="outlined"
              color="secondary"
              disabled={disabled}
              onClick={() => handleRemoveSubject(index)}
            >
              Remove
            </Button>
          </Box>
        </Box>
      ))}
      <Box className={classes.inputContainer}>
        <Button
          startIcon={<AddIcon />}
          onClick={handleAddSubject}
          color="secondary"
          disabled={disabled || formData.length >= maxSubjects}
        >
          Add Subject
        </Button>
      </Box>
    </Box>
  );
};
